// 医保所需的时间格式1 yyyyMMddHHmmss
const getFormatDate1 = () => {
  const yyyy = new Date().getFullYear();
  const MM = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
  const dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
  const HH = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
  const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
  const time = yyyy + MM + dd + HH + mm + ss;
  return time
}

// 医保所需的时间格式2 yyyy-MM-dd HH:mm:ss
const getFormatDate2 = () => {
  const yyyy = new Date().getFullYear();
  const MM = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
  const dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
  const HH = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
  const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
  const time = yyyy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss;
  return time
}

// 性别
const getGender = (num) => {
  let gender = '';
  switch (num) {
    case '0':
      gender = '未知';
      break;
    case '1':
      gender = '男';
      break;
    case '2':
      gender = '女';
      break;
    case '9':
      gender = '未说明性别';
      break;
    default:
      gender = '';
      break;
  }
  return gender;
}

// 民族
const getNationality = (num) => {
  let nationality = '';
  switch (num) {
    case '1':
      nationality = '汉族';
      break;
    case '2':
      nationality = '蒙古族';
      break;
    case '3':
      nationality = '回族';
      break;
    case '4':
      nationality = '藏族';
      break;
    case '5':
      nationality = '维吾尔族';
      break;
    case '6':
      nationality = '苗族';
      break;
    case '7':
      nationality = '彝族';
      break;
    case '8':
      nationality = '壮族';
      break;
    case '9':
      nationality = '布依族';
      break;
    case '10':
      nationality = '朝鲜族';
      break;
    case '11':
      nationality = '满族';
      break;
    case '12':
      nationality = '侗族';
      break;
    case '13':
      nationality = '瑶族';
      break;
    case '14':
      nationality = '白族';
      break;
    case '15':
      nationality = '土家族';
      break;
    case '16':
      nationality = '哈尼族';
      break;
    case '17':
      nationality = '哈萨克族';
      break;
    case '18':
      nationality = '傣族';
      break;
    case '19':
      nationality = '黎族';
      break;
    case '20':
      nationality = '傈僳族';
      break;
    case '21':
      nationality = '佤族';
      break;
    case '22':
      nationality = '畲族';
      break;
    case '23':
      nationality = '高山族';
      break;
    case '24':
      nationality = '拉祜族';
      break;
    case '25':
      nationality = '水族';
      break;
    case '26':
      nationality = '东乡族';
      break;
    case '27':
      nationality = '纳西族';
      break;
    case '28':
      nationality = '景颇族';
      break;
    case '29':
      nationality = '柯尔克孜族';
      break;
    case '30':
      nationality = '土族';
      break;
    case '31':
      nationality = '达斡尔族';
      break;
    case '32':
      nationality = '仫佬族';
      break;
    case '33':
      nationality = '羌族';
      break;
    case '34':
      nationality = '布朗族';
      break;
    case '35':
      nationality = '撒拉族';
      break;
    case '36':
      nationality = '毛南族';
      break;
    case '37':
      nationality = '仡佬族';
      break;
    case '38':
      nationality = '锡伯族';
      break;
    case '39':
      nationality = '阿昌族';
      break;
    case '40':
      nationality = '普米族';
      break;
    case '41':
      nationality = '塔吉克族';
      break;
    case '42':
      nationality = '怒族';
      break;
    case '43':
      nationality = '乌孜别克族';
      break;
    case '44':
      nationality = '俄罗斯族';
      break;
    case '45':
      nationality = '鄂温克族';
      break;
    case '46':
      nationality = '德昂族';
      break;
    case '47':
      nationality = '保安族';
      break;
    case '48':
      nationality = '裕固族';
      break;
    case '49':
      nationality = '京族';
      break;
    case '50':
      nationality = '塔塔尔族';
      break;
    case '51':
      nationality = '独龙族';
      break;
    case '52':
      nationality = '鄂伦春族';
      break;
    case '53':
      nationality = '赫哲族';
      break;
    case '54':
      nationality = '门巴族';
      break;
    case '55':
      nationality = '珞巴族';
      break;
    case '56':
      nationality = '基诺族';
      break;
    default:
      nationality = '';
      break;
  }
  return nationality;
}

// 险种
const getInsutype = (num) => {
  let insutype = '';
  switch (num) {
    case '310':
      insutype = '职工基本医疗保险';
      break;
    case '320':
      insutype = '公务员医疗补助';
      break;
    case '330':
      insutype = '大额医疗费用补助';
      break;
    case '340':
      insutype = '离休人员医疗保障';
      break;
    case '350':
      insutype = '一至六级残疾军人医疗补助';
      break;
    case '360':
      insutype = '老红军医疗保障';
      break;
    case '370':
      insutype = '企业补充医疗保险';
      break;
    case '380':
      insutype = '新型农村合作医疗';
      break;
    case '390':
      insutype = '城乡居民基本医疗保险';
      break;
    case '391':
      insutype = '城镇居民基本医疗保险';
      break;
    case '392':
      insutype = '城乡居民大病医疗保险';
      break;
    case '399':
      insutype = '其他特殊人员医疗保障';
      break;
    case '39905':
      insutype = '二乙医疗保险';
      break;
    case '410':
      insutype = '长期照护保险';
      break;
    case '510':
      insutype = '生育保险';
      break;
    default:
      insutype = '';
      break;
  }
  return insutype;
}

// 人员类别
const getPersonType = (num) => {
  let personType = '';
  switch (num) { 
    case '11':
      personType = '在职';
      break;
    case '1105':
      personType = '农名工';
      break;
    case '1111':
      personType = '伤残军人在职';
      break;
    case '1112':
      personType = '伤残军人退休';
      break;
    case '116003':
      personType = '失业人员';
      break;
    case '116013':
      personType = '在职副厅以上干部';
      break;
    case '116015':
      personType = '二等乙级在职职工';
      break;
    case '12':
      personType = '退休';
      break;
    case '1204':
      personType = '提前退休';
      break;
    case '126013':
      personType = '退休副厅以上干部';
      break;
    case '126015':
      personType = '退休残疾军人';
      break;
    case '13':
      personType = '离休';
      break;
    case '1302':
      personType = '二乙伤残军人';
      break;
    case '1304':
      personType = '离休配偶';
      break;
    case '136003':
      personType = '缴专项基金的建国前工人';
      break;
    case '136011':
      personType = '二等乙(市属离休)';
      break;
    case '136019':
      personType = '市属离休人员';
      break;
    case '1401':
      personType = '新生儿';
      break;
    case '1402':
      personType = '学龄前儿童';
      break;
    case '1403':
      personType = '中小学生';
      break;
    case '1404':
      personType = '大学生';
      break;
    case '1405':
      personType = '未成年（未入学）';
      break;
    case '15':
      personType = '居民（成年）';
      break;
    case '151':
      personType = '居民';
      break;
    case '16':
      personType = '居民（老年）';
      break;
    case '1701':
      personType = '城乡居民';
      break;
    case '18':
      personType = '农牧民中';
      break;
    case '33':
      personType = '一至六级残疾军人';
      break;
    case '34':
      personType = '建国前老工人';
      break;
    case '99':
      personType = '其他';
      break;
  }
  return personType;
}

// 通过行政区划区分省份
const getProvinceByCode = (code) => {
  const provinceCodes = {
    11: '北京市',
    12: '天津市',
    13: '河北省',
    14: '山西省',
    15: '内蒙古自治区',
    21: '辽宁省',
    22: '吉林省',
    23: '黑龙江省',
    31: '上海市',
    32: '江苏省',
    33: '浙江省',
    34: '安徽省',
    35: '福建省',
    36: '江西省',
    37: '山东省',
    41: '河南省',
    42: '湖北省',
    43: '湖南省',
    44: '广东省',
    45: '广西壮族自治区',
    46: '海南省',
    50: '重庆市',
    51: '四川省',
    52: '贵州省',
    53: '云南省',
    54: '西藏自治区',
    61: '陕西省',
    62: '甘肃省',
    63: '青海省',
    64: '宁夏回族自治区',
    65: '新疆维吾尔自治区',
    71: '台湾省',
    81: '香港特别行政区',
    82: '澳门特别行政区'
  };
  const provinceCode = code.toString().slice(0, 2);
  return provinceCodes[provinceCode] || '未知省份';
}



export {
  getGender,
  getNationality,
  getInsutype,
  getPersonType,
  getProvinceByCode,
  getFormatDate1,
  getFormatDate2
}